import { useQuery } from '@tanstack/react-query';
import { listTasks } from '../api';
import type { JobTaskQuery } from '@maker-toolchest/shared';

export function useTasks(query: JobTaskQuery) {
  return useQuery({
    queryKey: ['tasks', query],
    queryFn: () => listTasks(query),
    enabled: !!query.jobId, // Only fetch when we have a valid jobId
  });
}
